export default __webpack_public_path__ + "static/media/MVI.64330985.png";